<template>
  <div class="functionbar-mobile">
    <ButtonScroll
      :title="'Расcчитать стоимость'"
      :nameButton="'calc'"
      :nameImage="'calc'"
      :scrollSelector="'#calculator'"
    />
    <ButtonScroll
      :title="'Отделения на карте'"
      :nameButton="'branch'"
      :nameImage="'geo-thin'"
      :scrollSelector="'.map__find-branch'"
    />
    <ButtonRoute
      :title="$t('otsledit-posylku')"
      :nameButton="'tracking-package'"
      :nameImage="'mobile-find-track'"
      :route="'/tracking-page'"
    />
    <ButtonScroll
      :title="'Подключиться к Boxberry'"
      :nameButton="'join'"
      :nameImage="'join-icon'"
      :scrollSelector="'#form_ecom'"
    />
  </div>
</template>
<script>
import ButtonScroll from "../ComponentsFunctionBar/ButtonScroll.vue";
import ButtonRoute from "../ComponentsFunctionBar/ButtonRoute.vue";

export default {
  name: 'FunctionbarMobile',
  components: {
    ButtonScroll,
    ButtonRoute
  },
}
</script>
<!--<style lang="scss">-->
<!-- @import "FunctionbarEcommerce.scss";-->
<!--</style>-->
